enum AnnuityType
{
    Traditional = 0,
    GuaranteedIncome = 1
}

export default AnnuityType;
